import { useGetOrderQuery } from '@/core/graphql/hooks'

export function useGetOrder(orderId: string) {
  const { data, loading: isLoadingOrder } = useGetOrderQuery({ variables: { orderId: orderId }, skip: !orderId })
  return { order: data?.meetingLinkOrder, isLoadingOrder }
}
